import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hillsboroughConfig } from "./data";

export default function HillsboroughPage() {
  return <CityPageTemplate config={hillsboroughConfig} />;
}